/**
 * Retrieves the sort configuration from localStorage, or returns a default.
 * @param {string} localStorageKey The key for the sort configuration in localStorage.
 * @param {{key: string, dir: 'asc' | 'desc'}} defaultSort The default sort configuration.
 * @returns {{key: string, dir: 'asc' | 'desc'}} The stored or default sort configuration.
 */
export const getInitialSort = (localStorageKey, defaultSort) => {
    try {
        const item = localStorage.getItem(localStorageKey);
        const sort = JSON.parse(item);
        return sort || defaultSort;
    } catch (error) {
        return defaultSort;
    }
};

/**
 * Compares two alphanumeric values for sorting.
 * @param {string | number} a The first value.
 * @param {string | number} b The second value.
 * @returns {number} -1 if a < b, 1 if a > b, 0 if equal.
 */
export const compareAlphaNumericValues = (a, b) => {
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    return 0;
};

/**
 * Sorts an array of objects by a specified key and direction.
 * @param {Array<Object>} values The array of objects to sort.
 * @param {string} sortColumnKey The key in the objects to sort by.
 * @param {'asc' | 'desc'} [sortDir='asc'] The sort direction.
 * @returns {Array<Object>} The sorted array of objects.
 */
export const getSortedAlphaNumericValues = (values, sortColumnKey, sortDir = 'asc') => {
    if (!values || !sortColumnKey) {
        return [];
    }
    const sortedItems = values.toSorted((a, b) =>
        compareAlphaNumericValues(a[sortColumnKey], b[sortColumnKey]),
    );

    if (sortDir === 'desc') {
        return sortedItems.reverse();
    }
    return sortedItems;
};
